import {
  openVacancyDrawerById,
  type OpenDrawer,
} from "@/features/integrations/shared/utils/vacancyDrawerRowClick";

type RowClickOptions = {
  drawerTitle?: string;
  onError?: () => void;
};

/**
 * Creates a click handler for organic vacancy rows that opens the vacancy drawer.
 * Fetches the vacancy directly by its numeric ID — no pagination scan needed.
 */
export function createOrganicRowClickHandler(
  clientId: string,
  openDrawer: OpenDrawer,
  options?: RowClickOptions,
): (row: unknown) => Promise<void> {
  return async (row: unknown) => {
    if (typeof row !== "object" || row === null) return;
    const idValue = (row as Record<string, unknown>).id;
    const numericId = typeof idValue === "number" ? idValue : undefined;
    if (!numericId) return;

    try {
      await openVacancyDrawerById(
        clientId,
        numericId,
        openDrawer,
        options?.drawerTitle,
      );
    } catch (error) {
      console.error("Failed to fetch vacancy details:", error);
      options?.onError?.();
    }
  };
}
